/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-03-18 16:09:45
 * @LastEditTime: 2019-04-04 11:16:53
 */
// import {
//     queryproductbanner,
//     querybycategoryidesc,
//     queryproductdesc,
//     queryproductdescbyid,
//     queryhomecategoryid
// } from "@/api/productInfo";
import { queryosmenucateory } from "@/api/homePage";
import {
    getBreadcrum,
    getChildMenu,
    getMenu,
    getRightTop
} from "@/utils/breadcrum";
import router from "@/router";
import Cookies from "js-cookie";
const user = {
    state: {
        //头部菜单数组
        menuTop: [],
        //会员中心数组
        rightList: [],
        //底部菜单数组
        //获取当前菜单ID
        activeIndex: "",
        // 当前菜单对象
        activeMenu: {},
        brotherMenu: [],
        //当前菜单下的面包屑导航
        breadcrumbList: [],
        //历史id
        historyId: [],
        //历史记录下标
        historyIndex: 0,
        //ifarm链接地址
        outhref: "",
        //cookie获取用户名
        userName: "",
        //获取 当前菜单下的子菜单
        childMenu: [],
        bannerPath: "",
        contentlist: [],
        content: {},
        articleContent: {},
        parentList: []
    },

    mutations: {
        //获取当前菜单
        SETMENULIST: (state, menuList) => {
            state.rightList = getRightTop(menuList.top, "1");
            state.menuTop = menuList.top;
            state.activeIndex =
                sessionStorage.getItem("activeIndex") || state.menuTop[0].id;
        },
        //获取当前菜单ID
        SETACTIVE: (state, menuId) => {
            state.activeIndex = menuId;
        },
        //获取 当前菜单下的面包屑导航97AAB3AA-0B0C-D385-B987-2BA46580D87B  C2488E92-CBF9-C76B-52E8-8D02233B6C8D 97AAB3AA-0B0C-D385-B987-2BA46580D87B
        SETBREADCRUMB: state => {
            state.breadcrumbList = getBreadcrum(
                state.menuTop,
                state.activeIndex
            ).reverse();
        },
        //获取 当前菜单下的子菜单
        SETCHILdMENU: state => {
            state.childMenu = getChildMenu(state.menuTop, state.activeIndex);
        },
        //获取用户名
        USERNAME: (state, userName) => {
            state.userName = userName;
        },
        //获取 当前菜单下的兄弟
        SETBROTHERMENU: state => {
            let parentId =
                state.activeMenu.parentId || state.activeMenu.categoryId;
            state.brotherMenu = getChildMenu(state.menuTop, parentId);
        },
        SETTHIS: (state, id) => {
            state.activeMenu = getMenu(state.menuTop, id);
            //state.outhref = state.activeMenu.routAddressId;
            //     item || JSON.parse(sessionStorage.getItem("activeMenu"));
            // console.log(state.activeMenu);
            // sessionStorage.setItem(
            //     "activeMenu",
            //     JSON.stringify(state.activeMenu)
            // );
        },
        SETBANNERPATH: (state, imgPath) => {
            state.bannerPath = imgPath.image;
            //state.outhref = imgPath.routAddressId;
        },
        //外部地址
        SETSRC: (state, src) => {
            // state.bannerPath = imgPath.image;

            state.outhref = src;
        },
        SETCONTENTDESC: (state, content) => {
            state.content = content;
        },
        SETCONTENTDESCLIST: (state, list) => {
            state.contentlist = list;
        },
        PRODUCTDESBYID: (state, list) => {
            state.articleContent = list;
        },
        PARENTLIST: (state, list) => {
            state.parentList = list;
        }
    },
    actions: {
        //获取所有菜单
        QueryMenu({ commit }, menuId) {
            return new Promise((resolve, reject) => {
                queryosmenucateory(menuId)
                    .then(res => {
                        if (res.status === 2000) {
                            commit("SETMENULIST", res.data);
                            commit("SETCHILdMENU");
                            commit("SETTHIS");
                            resolve(res.data);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            });
        },
        //获取 当前菜单下  以及的面包屑导航、子菜单，跳转操作
        UpdateActive({ commit, dispatch }, item) {
            return new Promise(async resolve => {
                // store 赋值
                let openNew = item.opennew === "1" ? "_blank" : "_self";
                if (item.demoFlag == "无") {
                    return;
                }
                if (item.urlMenu === "1") {
                    return;
                } else if (item.urlMenu === "2" || item.urlMenu === "3") {
                    // 新闻跳转专用
                    if (item.articleId) {
                        let routeUrl = router.resolve({
                            path: item.demoFlag,
                            query: {
                                id: item.menuId,
                                contentid: item.articleId
                            }
                        });
                        window.open(routeUrl.href, openNew);
                    } else {
                        // 常规页面跳转
                        let indexId = item.id;
                        if (item.urlMenu === "3") {
                            let array = item.parentIds.split(",");
                            indexId = array[array.length - 1];
                        }
                        let routeUrl = router.resolve({
                            path: item.demoFlag,
                            query: {
                                id: indexId
                            }
                        });
                        window.open(routeUrl.href, openNew);
                    }
                } else if (item.urlMenu === "5") {
                    await commit("SETSRC", item.routAddress);
                    let routeUrl = router.resolve({
                        path: item.demoFlag,
                        query: {
                            id: item.id
                        }
                    });
                    window.open(routeUrl.href, openNew); //urlMenu: "5"
                } else {
                    window.open(item.routAddress, openNew);
                }
                console.log(item.id);
                await commit("SETCHILdMENU");
                resolve();
            });
        },
        MenuQueryAddressId({ commit }, MenuQueryDto) {
            return new Promise((resolve, reject) => {
                menuqueryaddressid(MenuQueryDto).then(res => {
                    commit("SETSRC", res.data.routAddress);
                });
            });
        },
        BannerPath({ commit }, activeIndex) {
            return new Promise((resolve, reject) => {
                // queryproductbanner(activeIndex).then(res => {
                //     commit("SETBANNERPATH", res.data);
                // });
            });
        },
        ContentDesc({ commit }, activeIndex) {
            return new Promise((resolve, reject) => {
                querybycategoryidesc(activeIndex).then(res => {
                    if (res.data) {
                        commit("SETCONTENTDESC", res.data);
                    } else {
                        let content = { title: "", description: "" };
                        commit("SETCONTENTDESC", content);
                    }
                });
            });
        },
        // ContentDescList({ commit }, activeIndex) {
        //     return new Promise((resolve, reject) => {
        //         queryproductdesc(activeIndex).then(res => {
        //             commit("SETCONTENTDESCLIST", res.data);
        //         });
        //     });
        // },
        ParentList({ commit }, activeIndex) {
            return new Promise((resolve, reject) => {
                // queryhomecategoryid(activeIndex).then(res => {
                //     let array = res.data;
                //     for (let index = 0; index < array.length; index++) {
                //         const element = array[index];
                //     }
                //     commit("PARENTLIST", res.data);
                // });
            });
        },
        // ProductdescById({ commit }, activeIndex) {
        //     return new Promise((resolve, reject) => {
        //         queryproductdescbyid(activeIndex).then(res => {
        //             // debugger;
        //             if (!res.data.new) {
        //                 commit("PRODUCTDESBYID", res.data);
        //             } else {
        //                 let articleContent = {
        //                     title: "",
        //                     description: "",
        //                     osArticleContent: { content: "" }
        //                 };
        //                 commit("PRODUCTDESBYID", articleContent);
        //             }
        //         });
        //     });
        // },
        saveUser({ commit }, user) {
            return new Promise((resolve, reject) => {
                if (user) {
                    if (user.userName) {
                        commit("USERNAME", user.userName);
                    } else if (
                        user.phoneNumber &&
                        user.phoneNumber.length > 7
                    ) {
                        let phone =
                            user.phoneNumber.substr(0, 3) +
                            "****" +
                            user.phoneNumber.substr(7);
                        commit("USERNAME", phone);
                    }
                } else {
                    commit("USERNAME", "");
                }
            });
        },
        setHistory({ commit, dispatch, state }, id) {
            // dispatch("ProductdescById", id);
            // dispatch("ContentDescList", id);
            return new Promise(async resolve => {
                console.log(state.menuTop);
                if (state.menuTop.length === 0) {
                    await queryosmenucateory(
                        "D4DCDE8D-5BDD-6549-5E29-ECC91A5FD4EF"
                    ).then(res => {
                        if (res.status === 2000) {
                            console.log(res.data);
                            commit("SETMENULIST", res.data);
                            resolve(res.data);
                        }
                    });
                }
                sessionStorage.setItem("activeIndex", id);
                await commit("SETACTIVE", id);
                await commit("SETTHIS", id);
                await commit("SETBROTHERMENU");
                await commit("SETBREADCRUMB");
                if (id) {
                    await dispatch("BannerPath", id);
                }
            });
        }
    }
};

export default user;
